import { render } from "./EmConstrucao.vue?vue&type=template&id=f6f608b6&scoped=true"
import script from "./EmConstrucao.vue?vue&type=script&lang=js"
export * from "./EmConstrucao.vue?vue&type=script&lang=js"

import "./EmConstrucao.vue?vue&type=style&index=0&id=f6f608b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6f608b6"]])

export default __exports__